export default "__VITE_ASSET__kC83nbnN__"